module.exports = __webpack_public_path__ + "img/5.7e574711.svg";